module.exports = __webpack_public_path__ + "static/media/DSC04983.ca3b8813.JPG";